import {AfterViewInit, Component, NgZone, OnInit} from '@angular/core';
import {UserService} from "../../../service/user.service";
import {Router} from "@angular/router";

import * as _ from 'lodash';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {PasswordMatch} from "../../../service/passwordMatch";
import {environment} from "../../../../environments/environment";
import {Store} from "@ngrx/store";
import {AppState} from "../../../models/app.state";
import {isNullOrUndefined} from "util";
import { eventEmitterService } from '../../../service/eventEmitter.service';
import { HttpService } from '../../../service/http.service';
import { UpgradeService } from '../../../service/upgrade.service';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
declare var $:any;

@Component({
  selector: 'app-user-account-settings',
  templateUrl: './user-account-settings.component.html',
  styleUrls: ['./user-account-settings.component.css'],
})
export class UserAccountSettingsComponent implements OnInit, AfterViewInit {
  // Local storage variables
  id = localStorage.getItem('residents');
  isManager = localStorage.getItem('isManager');
  userBuildingId = localStorage.getItem('userBuildingId');

  // Account setting declarations
  passwordReset: FormGroup;
  editAccountForm: FormGroup;
  user;
  userProfileImage = '';
  newProfileImage = '';

  // Error Flags - User account form
  firstNameInvalid = false;
  lastNameInvalid = false;
  phoneInvalid = false;
  emailInvalid = false;
  isEmailExists = false;
  isSuccess = false;
  isError = false;

  // Error Flags - change password form
  passInvalid = false;
  confirmPassInvalid = false;
  oldPassInvalid = false;
  passMatchInvalid = false;
  isPasswordUpdated = false;
  isPasswordUpdateError = false;
  isAccountDeactivated = false;
  userImageObj:any;

  userExistingProfileVal;
  updatedProfileImage = '';

  // Observables and environment vars
  oldPassSub: Subject<any> = new Subject();
  emailSub: Subject<any> = new Subject();
  environmentUrl = environment.apiUrl;
  s3apiUrl = environment.s3BucketApi;

  //Image upload
  isImage = false;
  timer;
  dateUpdater = '?ver='+Date.now();
  error;

  constructor(private userService:UserService,
              private router: Router,
              private fb: FormBuilder,
              private http: HttpClient,
              private store: Store<AppState>,
              private eventService: eventEmitterService,
              private ngZone: NgZone,
              private httpService: HttpService,
              private upgradeService: UpgradeService) { }

  ngOnInit() {

    this.passwordReset = this.fb.group({
        pass        : ['', Validators.compose([Validators.required, Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,15}$'),Validators.minLength(5), Validators.maxLength(15)])],
        confirmPass     : ['', [Validators.required]],
        oldPass: ['', [Validators.required]]
      });

    this.editAccountForm = this.fb.group({
      firstname: ['', [Validators.required, Validators.maxLength(50), Validators.pattern('^([a-zA-Z-\'])+([a-zA-Z- ]+)?$')]],
      lastname: ['', [Validators.required, Validators.maxLength(50), Validators.pattern('^([a-zA-Z-\'])+([a-zA-Z- ]+)?$')]],
      email: ['', [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
      phone: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(15), Validators.pattern(/^(?=.*[0-9])[- +()0-9]+$/)]],
      type:['']
    });

    // If user ID not found, logout
    if(_.isUndefined(this.id) || _.isEmpty(this.id)){
      location.href = '/';
    }

    // Observable implementation to perform an action if there is any change in value
    this.oldPassSub.subscribe(
      (data) => {
        this.oldPassInvalid = data;
      }
    );

    this.emailSub.subscribe(
      (data) => {
        var bdata=data;
        this.isEmailExists = bdata;
      }
    );
    // -----------------------------------

    // Set all error flag values for dynamic update based on events
    // if(this.editAccountForm.get('firstname').invalid && this.editAccountForm.get('firstname').touched){
    //   this.firstNameInvalid = true;
    // }

    // if(this.editAccountForm.get('lastname').invalid && this.editAccountForm.get('lastname').touched){
    //   this.firstNameInvalid = true;
    // }

    // if(this.editAccountForm.get('phone').invalid && this.editAccountForm.get('phone').touched){
    //   this.firstNameInvalid = true;
    // }

    // if(this.editAccountForm.get('email').invalid && this.editAccountForm.get('email').touched){
    //   this.firstNameInvalid = true;
    // }

    // Runs every 4 seconds to update new user image across the entire site, if uploaded
    // this.timer = Observable.timer(10000,20000)
    //   .subscribe(i => {

    //     // Check if the sessionStorage already has user profile image value
    //     if(!isNullOrUndefined(sessionStorage.getItem('userProfileImage'))) {
    //       // if (sessionStorage.getItem('userProfileImage') !== null && sessionStorage.getItem('userProfileImage')) {
    //       //   if (sessionStorage.getItem('userProfileImage').split('assets').length > 1) {
    //       //     this.userProfileImage = this.environmentUrl + sessionStorage.getItem('userProfileImage').split('assets')[1];
    //       //   }
    //       // } else if (sessionStorage.getItem('userProfileImage')) {
    //       //   this.userProfileImage = sessionStorage.getItem('userProfileImage');
    //       // } else {
    //       //   this.userService.getUserProfileImageByUserId(this.id).subscribe(
    //       //     (user) => {
    //       //       if (user) {
    //       //         this.userProfileImage = (user.profileImage && user.profileImage.split('assets').length > 1) ? user.profileImage.split('assets')[1] : (user.profileImage) ? user.profileImage : sessionStorage.getItem('userImage');
    //       //       }
    //       //     }
    //       //   );
    //       // }
    //     }

    //   });

    this.store.subscribe(
      (data) => {
        console.log('Image Data : ', data);
        this.userImageObj = data.build[0];
      }
    );

  }



  ngAfterViewInit() {

    // Get Current User By ID and load the details on corresponding fields
    this.userService.getUserById(this.id).subscribe(
      (user) => {
        console.log('Current User : ', user);
        if(user.success){
          this.user = user.user;
          this.userProfileImage = (user.user.profilePicture && user.user.profilePicture.split('assets').length > 1) ? this.environmentUrl + user.user.profilePicture.split('assets')[1] : (user.user.profilePicture && user.user.profilePicture.split('user').length > 1) ? this.s3apiUrl + user.user.profilePicture : '';
          this.newProfileImage = this.userProfileImage;
          this.editAccountForm.get('firstname').patchValue(this.user.firstName);
          this.editAccountForm.get('lastname').patchValue(this.user.lastName);
          this.editAccountForm.get('email').patchValue(this.user.email);
          this.editAccountForm.get('phone').patchValue(this.user.country.number);
          this.editAccountForm.get('type').patchValue(this.user.type);


          this.userExistingProfileVal = {
            firstName: this.user.firstName,
            lastName: this.user.lastName,
            email: this.user.email,
            phone: this.user.country.number,
            type: this.user.type
          }
        }
      }
    );
  }

  /**
   * Handler to save any changes made to the user profile information
   * Pass the values to service layer to update the User model
   * Perform validation check
   * Response: Saved user with updated values
   */
  onSaveSettingSubmit(){
    this.isEmailExists = false;
      console.log(this.editAccountForm.value, this.editAccountForm);
    const userData = {
      firstname: this.editAccountForm.value.firstname,
      lastname: this.editAccountForm.value.lastname,
      email: this.editAccountForm.value.email,
      phone: this.editAccountForm.value.phone,
      type:this.editAccountForm.value.type,
      id: this.id,
      image: (this.updatedProfileImage) ? this.updatedProfileImage : null,
    };

      if(this.editAccountForm.value.email !== this.userExistingProfileVal.email) {
        this.userService.isEmailExists(userData.email).subscribe(
          (user: any) => {
            if(user.status) {
              this.emailSub.next(true);
            } else{
              this.emailSub.next(false);
            }
          }
        );
      }else{
        this.isEmailExists = false;
      }

      if(this.editAccountForm.valid && !this.isEmailExists){
        this.userService.updateUserDetails(userData).subscribe(
          (user) => {

            this.eventService.eventEmit$.next({profilepictureUpdate: true, updatedUser: user})
            console.log('User updated : ', user);
            if(user.success){
              this.isSuccess = true;
              this.isError = false;
            }else{
              this.isSuccess = false;
              this.isError = true;
            }
            setTimeout(
              () => {
                this.isSuccess = false;
                this.isError = false;
                this.emailSub.next(false);

              }, 3000
            );
          }
        );
      }


  }

  isImageUpdate(e){
    if (e) this.isImage = true;

  }

  /**
   * Opens the image upload modal programmatically.
   */
  openImageUploadModal() {
    $('#img_upload_modal').modal('show');
    // this.eventService.eventEmit$.next({modalOpen: true});
  }

  /**
   * Handler to deactivate user account
   */
  deactivateAccount() {

    this.upgradeService.userSetup(this.id);

   //if(confirm('Do you really want to deactivate your account?')) {
    //  this.userService.disableUserById(this.id).subscribe(
    //    (user) => {
    //      if(user.success){
    //        this.isAccountDeactivated = true;
    //        console.log('Deactivate : ',user);
    //        setTimeout(
    //          () => {
    //            this.http.get(environment.apiUrl + 'auth/logout', {withCredentials: true}).map(res => res.json()).subscribe(
    //              (data) => {
    //                if(data.success){
    //                  // Logout user if deactivated
    //                  window.location.href = '/';
    //                }
    //              }
    //            );
    //          }
    //        )
    //        ;        }
    //    }
    //  );
  // }
  }

  /**
   * Handler to reset password submitted through Change password form
   * Validation checks are performed after which the values are passed on to the service layer
   */
  reset(){
    console.log('Form submit: ', this.passwordReset.value);

    if(this.passwordReset.value.oldPass){
      this.userService.checkOldPassword(this.passwordReset.value.oldPass, this.id).subscribe(
        (password) => {

          console.log('Old Password Valid ? ', password);
          if(password.success){
            this.oldPassInvalid = false;
            this.oldPassSub.next(false);
            if(this.passwordReset.get('pass').valid){
              this.passInvalid = false;
            }else {
              this.passInvalid = true;
            }

            if(this.passwordReset.get('confirmPass').valid){
              this.confirmPassInvalid = false;
            }else {
              this.confirmPassInvalid = true;
            }

            if(this.passwordReset.value.pass === this.passwordReset.value.confirmPass) {
              this.passMatchInvalid = false;
            }else {
              this.passMatchInvalid = true;
            }

            if(!this.oldPassInvalid && !this.passMatchInvalid && !this.passInvalid && !this.confirmPassInvalid && this.passwordReset.valid){
              this.userService.storeNewPassword(this.passwordReset.value.pass, this.id).subscribe(
                (data) => {
                  console.log ('Password updated : ', data);
                  if(data.success){
                    this.isPasswordUpdated = true;
                    this.isPasswordUpdateError = false;
                    this.passwordReset.reset();
                    setTimeout(
                      () => {
                        this.isPasswordUpdated = false;
                        this.isPasswordUpdateError = false;
                        $('#reset_modal .close').trigger('click');
                      }, 3000
                    );
                  }else {
                    this.isPasswordUpdateError = true;
                    this.isPasswordUpdated = false;
                  }

                }
              );
            }
          }else {
            this.oldPassSub.next(true);
            this.oldPassInvalid = true;
          }
        }
      );
    }else{
      this.oldPassInvalid = true;
    }

  }

  /**
   * Updates user profile image on current page after saving
   * @param image
   */
  updateSource(image) {
    $('#account_settings .profile_img_wrap img#user-profile-image').attr('src', image);

    this.updatedProfileImage = image;
  }

  upgradeAccount(){

  }

}
